

// Collection list item Read more
const maxLength = 110;
const descElements = document.querySelectorAll('.collection-section-desc');
descElements.forEach(descElement => {
  const text = descElement.textContent;
  if (text.length > maxLength) {
    const shortDesc = text.substring(0, maxLength) + '...';
    const fullDesc = text;
    descElement.textContent = '';
    const textContainer = document.createElement('span');
    textContainer.textContent = shortDesc;
    const readMoreLink = document.createElement('a');
    readMoreLink.textContent = 'Read more';
    readMoreLink.href = '#';
    readMoreLink.classList.add('read-more-btn');
    readMoreLink.style.display = 'inline';
    readMoreLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (textContainer.textContent === shortDesc) {
        textContainer.textContent = fullDesc;
        readMoreLink.textContent = 'Read less';
      } else {
        textContainer.textContent = shortDesc;
        readMoreLink.textContent = 'Read more';
      }
    });
    descElement.appendChild(textContainer);
    descElement.appendChild(readMoreLink);
  }
});
